import { IMapOptions } from "../interfaces/mapoptions";

// extracts the mapoptions from a window
export function getMapOptions(): IMapOptions{
    const mapoptions: IMapOptions = (<any>window).mapOptions;
    return mapoptions;
}